import {wrapAddPanelIcon} from '@packages/systems/ui/shared-ui/wrapAddPanelIcon';
import {
  AddPanelSearch64Icon,
  ElementSearchResultsIcon as SearchResultsIcon,
  SearchDefaultIcon as SearchIcon,
} from '@packages/systems/spring';
import SearchForm from './SearchForm';
import SearchInput from './SearchInput';
import SearchButton from './SearchButton';
import SearchResultEmpty from './SearchResultEmpty';
import SearchResultWrapper from './SearchResultWrapper';
import SearchResultList from './SearchResultList';
import SearchResultItem from './SearchResultItem';
import {SearchFormType} from './dataTypes/SearchFormType';
import {getUniqueFormIdAndLabel} from '@packages/utilities/platform';
import {Plugins, ElementPreset, Component} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {Note} from './dataTypes/SearchResultsNote';
import {SearchIndexBoolean} from './dataTypes/SearchIndexBoolean';

const SearchAddPanelIcon = wrapAddPanelIcon(AddPanelSearch64Icon);

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  ENumber,
  EList,
} from '@packages/systems/wfdl-ast';

export const plugin = Plugins.PrivilegedPlugin({
  icons: {
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    AddPanelSearch: SearchAddPanelIcon,
    Search: SearchIcon,
    SearchResults: SearchResultsIcon,
  },
  atoms: {
    SearchForm,
    SearchInput,
    SearchButton,
    SearchResultEmpty,
    SearchResultWrapper,
    SearchResultList,
    SearchResultItem,
  },
  dataTypes: {Note, SearchFormType, SearchIndexBoolean},
  stateAtom: 'SearchResultWrapper',

  elementPresets: {
    SearchForm: ElementPreset.create({
      factory: ({componentMap}) => {
        if (componentMap === undefined) {
          throw Error(
            'componentMap is required to instantiate SearchForm elementPreset'
          );
        }
        const {id} = componentMap
          ? getUniqueFormIdAndLabel(componentMap, 'search')
          : {id: 'search'};

        return EElement({
          id: 'Search Form',
          type: qualify(Plugins.name('Search'), Component.name('SearchForm')),
          data: ERecord({
            attr: ERecord({
              action: EText('/search'),
            }),
            search: ERecord({
              type: EText('form'),
              exclude: EBoolean(true),
            }),
            children: EList([
              EElement({
                id: 'Form Block Label',
                type: qualify(
                  Plugins.name('Form'),
                  Component.name('FormBlockLabel')
                ),
                data: ERecord({
                  form: ERecord({
                    type: EText('label'),
                    passwordPage: EBoolean(false),
                  }),
                  attr: ERecord({
                    for: EText('search'),
                  }),
                  children: EList([
                    EElement({
                      id: 'Search Form String',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('String')
                      ),
                      data: EText('Search'),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: 'Search Input',
                type: qualify(
                  Plugins.name('Search'),
                  Component.name('SearchInput')
                ),
                data: ERecord({
                  attr: ERecord({
                    autofocus: EBoolean(false),
                    disabled: EBoolean(false),
                    maxlength: ENumber(256),
                    name: EText('query'),
                    placeholder: EText('Search\u2026'),
                    required: EBoolean(true),
                    type: EText('search'),
                    id: EText(id),
                  }),
                  search: ERecord({
                    type: EText('input'),
                    exclude: EBoolean(true),
                  }),
                }),
              }),
              EElement({
                id: 'Search Button',
                type: qualify(
                  Plugins.name('Search'),
                  Component.name('SearchButton')
                ),
                data: ERecord({
                  attr: ERecord({
                    type: EText('submit'),
                    value: EText('Search'),
                  }),
                  search: ERecord({
                    type: EText('button'),
                    exclude: EBoolean(true),
                  }),
                }),
              }),
            ]),
          }),
        });
      },
      helpData: {
        description: [
          'Allow visitors to search any page. Customize search results, forms, and exclude entire pages in Settings.',
        ],
        videoSrc:
          'https://d3e54v103j8qbb.cloudfront.net/videos/tooltips/d2/search.dd0a122db4.mp4',
      },
      icon: {
        small: qualify(Plugins.name('Search'), iconName('SearchResults')),
        medium: qualify(Plugins.name('Search'), iconName('AddPanelSearch')),
      },
      label: 'Search',
      category: ({canAccessSiteSearch}) => {
        if (!canAccessSiteSearch) return null;
        return 'Other';
      },
      addTabIndex: 3,
    }),
  },
});
